import { EventDto } from "@api";
import RRule from "rrule";

export const sortByNextExecution = (a: EventDto, b: EventDto, direction: "asc" | "desc" = "desc"): number => {
  const aDate = a.recurrence ? RRule.fromString(a.recurrence).after(new Date()) : new Date(a.date);
  const bDate = b.recurrence ? RRule.fromString(b.recurrence).after(new Date()) : new Date(b.date);

  return direction === "asc" ? bDate.getTime() - aDate.getTime() : aDate.getTime() - bDate.getTime();
};
